module.exports = __webpack_public_path__ + "static/media/infoSettings.047e637c.svg";